"use client";

import { useEffect, useState } from "react";
import {
  getDefaultPublicListingBackLink,
  resolvePublicListingBackLink,
  type PublicListingKind,
} from "@/lib/utils/publicListingReturn";
import type { PublicBackLink } from "@/lib/utils/publicReturnToClass";

export function usePublicListingBackLink(
  kind: PublicListingKind,
): PublicBackLink {
  const fallback = getDefaultPublicListingBackLink(kind);
  const [link, setLink] = useState<PublicBackLink>(fallback);

  useEffect(() => {
    setLink(resolvePublicListingBackLink(kind));
  }, [kind]);

  return link;
}
